import React from "react";
import styled, { css } from "styled-components";
import { colors } from "utils";
import { WHITE, interText } from "components/pages/WarmUpPicker/styles";
import { CopyIcon, KebabIcon, PencilIcon, TrashIcon } from "./warmUpCardIcons";
import { useMenuButton } from "./useMenuButton";

// The warm-up card's kebab and its menu (Figma 6463:8076).

export const WarmUpGroupMenu = ({ buttonId, setName, isOpen, onOpenChange, onCopyToClasses, onEdit, onArchive }) => {
  const items = [
    { label: "Copy to Classes", Icon: CopyIcon, action: onCopyToClasses },
    { label: "Edit Groups", Icon: PencilIcon, action: onEdit },
    { label: "Archive Groups", Icon: TrashIcon, action: onArchive },
  ];
  const menu = useMenuButton({ idPrefix: "warm-up-group-menu", itemCount: items.length, isOpen, onOpenChange });

  return (
    <Wrapper {...menu.wrapperProps}>
      <KebabButton {...menu.buttonProps} id={buttonId} aria-label={`Actions for ${setName} warm-up groups`}>
        <KebabIcon />
      </KebabButton>
      {menu.isOpen && (
        <CardMenu {...menu.menuProps} aria-label={`${setName} warm-up groups`}>
          {items.map(({ label, Icon, action }, index) => (
            <MenuItem key={label} {...menu.itemProps(index, action)}>
              <Icon />
              {label}
            </MenuItem>
          ))}
        </CardMenu>
      )}
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  display: flex;
  position: relative;
`;

export const KebabButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  height: 24px;
  padding: 0;
  width: 24px;
`;

// The 1px border is Figma's inside stroke, drawn over the rows so each keeps
// the menu's full 172px width.
export const Menu = styled.div`
  background: ${WHITE};
  border-radius: 6px;
  box-shadow: none;
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  width: 172px;
  z-index: 200;

  &::after {
    border: 1px solid ${colors.blue300};
    border-radius: 6px;
    bottom: 0;
    content: "";
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

// Figma's placement on the warm-up card: 6px under the kebab, the right edge
// 7px past the kebab's, which keeps the menu inside the card.
const CardMenu = styled(Menu)`
  right: -7px;
  top: calc(100% + 6px);
`;

const keyboardFocusBar = css`
  box-shadow: inset 3px 0 0 ${colors.blue500};
`;

export const MenuItem = styled.button`
  ${interText(14, 20, 400, "0")}
  align-items: center;
  background: ${(p) => (p.$active ? colors.blue50 : WHITE)};
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  gap: 10px;
  height: 40px;
  margin: 0;
  padding: 8px;
  text-align: left;
  white-space: nowrap;
  width: 100%;

  &:focus,
  &:focus-visible {
    outline: none;
  }
  ${(p) => p.$keyboardFocus && keyboardFocusBar}
`;
